import { render, staticRenderFns } from "./permissionGrantTree.vue?vue&type=template&id=08e6d2a4&scoped=true&"
import script from "./permissionGrantTree.vue?vue&type=script&lang=ts&"
export * from "./permissionGrantTree.vue?vue&type=script&lang=ts&"
import style0 from "./permissionGrantTree.vue?vue&type=style&index=0&id=08e6d2a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e6d2a4",
  null
  
)

export default component.exports